import { i18n } from "@lingui/core";
import React from 'react';
import { Link } from 'gatsby';
import { useLingui } from '@lingui/react';
import './pagination.scss';

var Pagination = function Pagination(_ref) {
  var context = _ref.context;
  console.log({
    context: context
  });
  var currentPage = context.currentPage,
      totalPages = context.totalPages,
      pathPrefix = context.pathPrefix;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var isFirst = currentPage === 1;
  var isLast = currentPage === totalPages;
  var prevPage = currentPage - 1 === 1 ? '' : (currentPage - 1).toString();
  var nextPage = (currentPage + 1).toString(); // To prevent from putting dots multiple times
  // ex: 1 .. 3 4 5 .. 27 <-- only once for each side

  var hasDotsLeft = false;
  var hasDotsRight = false;
  return /*#__PURE__*/React.createElement("ul", {
    className: "pagination"
  }, !isFirst && /*#__PURE__*/React.createElement(Link, {
    to: pathPrefix + "/" + prevPage,
    rel: "prev"
  }, /*#__PURE__*/React.createElement("span", null, "\xAB\xA0"), i18n._(
  /*i18n*/
  i18n._("prev"))), Array.from({
    length: totalPages
  }, function (_, i) {
    // Because page starts with "1", not 0
    ++i;

    if (i === 1 || // first page
    i === totalPages || // last page
    i >= currentPage - 1 && i <= currentPage + 1) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, /*#__PURE__*/React.createElement(Link, {
        to: pathPrefix + "/" + (i === 1 ? '' : i),
        activeClassName: "pagination__num--active"
      }, i));
    } else if (1 < i && i < currentPage - 1) {
      if (hasDotsLeft) return null;
      hasDotsLeft = true;
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, "..");
    } else if (currentPage + 1 < i && i < totalPages) {
      if (hasDotsRight) return null;
      hasDotsRight = true;
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, "..");
    } else {
      return null;
    }
  }), !isLast && /*#__PURE__*/React.createElement(Link, {
    to: pathPrefix + "/" + nextPage,
    rel: "next"
  }, i18n._(
  /*i18n*/
  i18n._("next")), /*#__PURE__*/React.createElement("span", null, "\xA0\xBB")));
};

export default Pagination;